/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'
import { FashionProductionOrderData } from '../pages/ClientPanel/ProductionFashion/FashionPcp'

interface ModalContextProps {
  modalActive: boolean
  setModalActive: React.Dispatch<React.SetStateAction<boolean>>
  modalSection: string
  setModalSection: React.Dispatch<React.SetStateAction<string>>
  itIsUpdate: boolean
  setItIsUpdate: React.Dispatch<React.SetStateAction<boolean>>
  lastSection:string
  setLastSection:React.Dispatch<React.SetStateAction<string>>
  selectedProductionOrder: any | null; // Armazena a OP selecionada
  setSelectedProductionOrder: (order: any | null) => void; // Função para definir a OP
  selectedCompany: any | null; // Armazena a empresa selecionada para edição
  setSelectedCompany: (company: any | null) => void; // Função para definir a empresa
}

const ModalContext = createContext<ModalContextProps>({
  modalActive: false,
  setModalActive: () => {},
  modalSection: '',
  setModalSection: () => {},
  itIsUpdate: false,
  setItIsUpdate: () => {},
  lastSection:'',
  setLastSection:() => {},
  selectedProductionOrder: null,
  setSelectedProductionOrder: () => {},
  selectedCompany: null,
  setSelectedCompany: () => {}
})

export default ModalContext

export const ModalProvider: React.FC<any> = ({ children }) => {
  const [ modalActive, setModalActive ] = useState<boolean>(false)
  const [ modalSection, setModalSection ] = useState<string>('stock')
  const [ itIsUpdate, setItIsUpdate ] = useState<boolean>(false)
  const [ lastSection, setLastSection ] = useState<string>('')
  const [selectedProductionOrder, setSelectedProductionOrder] = useState<any | null>(null); 
  const [selectedCompany, setSelectedCompany] = useState<any | null>(null);
  
  // Wrapper para setModalSection com logs
  const setModalSectionWithLogs = (value: React.SetStateAction<string>) => {
    const newSection = typeof value === 'function' ? value(modalSection) : value;
    
    console.log('🔄 [MODAL-CONTEXT] Mudando seção do modal:', {
      from: modalSection,
      to: newSection,
      timestamp: new Date().toISOString(),
      modalActive
    });
    
    setLastSection(modalSection);
    setModalSection(value);
    
    console.log('✅ [MODAL-CONTEXT] Seção alterada com sucesso:', {
      currentSection: newSection,
      previousSection: modalSection,
      isActive: modalActive
    });
  };
  
  // Wrapper para setModalActive com logs
  const setModalActiveWithLogs = (value: React.SetStateAction<boolean>) => {
    const newActive = typeof value === 'function' ? value(modalActive) : value;
    
    console.log('🔄 [MODAL-CONTEXT] Mudando estado do modal:', {
      from: modalActive,
      to: newActive,
      currentSection: modalSection,
      timestamp: new Date().toISOString()
    });
    
    setModalActive(value);
    
    if (!newActive) {
      console.log('💫 [MODAL-CONTEXT] Modal fechado - limpando contexto');
    } else {
      console.log('✅ [MODAL-CONTEXT] Modal aberto na seção:', modalSection);
    }
  }; 

  return (
    <ModalContext.Provider
      value={{
        modalActive,
        setModalActive: setModalActiveWithLogs,
        modalSection,
        setModalSection: setModalSectionWithLogs,
        itIsUpdate,
        setItIsUpdate,
        lastSection,
        setLastSection,
        selectedProductionOrder, 
        setSelectedProductionOrder,
        selectedCompany,
        setSelectedCompany
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}
